<!--
  PREVENTIVO › PACCHETTO VALET.

  Il venditore ha davanti il cliente: chiede il suo indirizzo e la sede più
  vicina (una delle sedi del partner, oppure un indirizzo scritto a mano). Il
  server calcola la distanza SU STRADA, trova la fascia del listino valet e
  restituisce il prezzo di un pickup all'anno per pacchetti da 1, 2 o 3 pickup
  all'anno. Qui si moltiplica per i pickup e per i mesi scelti.

  A sinistra il prezzo del venditore (quello che paga il cliente), accanto quello
  Simba. Importi senza IVA.
-->
<template>
  <div class="pvv">
    <section class="pvv__card">
      <header class="pvv__head">
        <h2 class="pvv__title">
          Cliente e sede
        </h2>
        <p class="pvv__note">
          La fascia dipende dalla distanza su strada fra la casa del cliente e la sede.
        </p>
      </header>

      <div class="pvv__body">
        <div class="pvv__label">
          Indirizzo del cliente
        </div>
        <div class="pvv__grid">
          <div class="pvv__f pvv__f--2">
            <label for="pvv-via">Via / Piazza</label>
            <el-input
              id="pvv-via"
              v-model="cliente.address"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-civico">Civico</label>
            <el-input
              id="pvv-civico"
              v-model="cliente.street_number"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-cap">CAP</label>
            <el-input
              id="pvv-cap"
              v-model="cliente.cap"
              maxlength="5"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-citta">Città</label>
            <el-input
              id="pvv-citta"
              v-model="cliente.city"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-provincia">Provincia</label>
            <el-input
              id="pvv-provincia"
              v-model="cliente.province"
              maxlength="2"
              placeholder="es. BG"
            />
          </div>
        </div>

        <div class="pvv__label">
          Sede
        </div>
        <div
          class="pvv__seg"
          role="radiogroup"
          aria-label="Come scegli la sede"
        >
          <button
            type="button"
            role="radio"
            :aria-checked="modoSede === 'sede'"
            :class="{ 'is-on': modoSede === 'sede' }"
            :disabled="!sedi.length"
            @click="modoSede = 'sede'"
          >
            Una delle mie sedi
          </button>
          <button
            type="button"
            role="radio"
            :aria-checked="modoSede === 'libera'"
            :class="{ 'is-on': modoSede === 'libera' }"
            @click="modoSede = 'libera'"
          >
            Scrivi l'indirizzo
          </button>
        </div>

        <el-select
          v-if="modoSede === 'sede'"
          v-model="sedeId"
          placeholder="Scegli la sede"
          class="pvv__sede"
        >
          <el-option
            v-for="s in sedi"
            :key="s.id"
            :label="etichettaSede(s)"
            :value="s.id"
          />
        </el-select>
        <div
          v-else
          class="pvv__grid"
        >
          <div class="pvv__f pvv__f--2">
            <label for="pvv-sede-via">Via / Piazza</label>
            <el-input
              id="pvv-sede-via"
              v-model="sedeLibera.address"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-sede-civico">Civico</label>
            <el-input
              id="pvv-sede-civico"
              v-model="sedeLibera.street_number"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-sede-cap">CAP</label>
            <el-input
              id="pvv-sede-cap"
              v-model="sedeLibera.cap"
              maxlength="5"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-sede-citta">Città</label>
            <el-input
              id="pvv-sede-citta"
              v-model="sedeLibera.city"
            />
          </div>
          <div class="pvv__f">
            <label for="pvv-sede-provincia">Provincia</label>
            <el-input
              id="pvv-sede-provincia"
              v-model="sedeLibera.province"
              maxlength="2"
            />
          </div>
        </div>

        <div class="pvv__actions">
          <span
            v-if="tentato && problema"
            class="pvv__err"
            role="alert"
          >{{ problema }}</span>
          <span class="pvv__spacer" />
          <el-button
            type="primary"
            :loading="calcolo"
            @click="calcola"
          >
            Calcola preventivo
          </el-button>
        </div>
      </div>
    </section>

    <section
      v-if="risultato"
      class="pvv__card"
      aria-live="polite"
    >
      <header class="pvv__head">
        <h2 class="pvv__title">
          Preventivo
        </h2>
        <p class="pvv__note">
          {{ risultato.km.toLocaleString('it-IT') }} km su strada ·
          <template v-if="risultato.band">
            fascia {{ fascia(risultato.band) }}
          </template>
          <template v-else>
            fuori dal listino valet
          </template>
          <template v-if="risultato.scope === 'global'">
            · listino generale Simba
          </template>
        </p>
      </header>

      <div
        v-if="!risultato.band"
        class="pvv__body"
      >
        <p class="pvv__empty">
          Per questa distanza il listino non ha una fascia: il pacchetto valet non si può
          preventivare. Parlane con Simba.
        </p>
      </div>

      <div
        v-else
        class="pvv__body"
      >
        <div class="pvv__mesi">
          <label for="pvv-mesi">Durata</label>
          <el-input-number
            id="pvv-mesi"
            v-model="mesi"
            :min="1"
            :max="120"
            :step="1"
            step-strictly
            controls-position="right"
          />
          <span class="pvv__help">mesi</span>
        </div>

        <div class="pvv__scroll">
          <table class="pvv__tab">
            <thead>
              <tr>
                <th>Pickup all'anno</th>
                <th class="num">
                  Al cliente, al mese
                </th>
                <th class="num">
                  Al cliente, all'anno
                </th>
                <th class="num">
                  Totale in {{ mesi }} mesi
                </th>
                <th class="num">
                  Simba, al mese
                </th>
                <th class="num">
                  Valet compresi
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="r in righe"
                :key="r.pickup"
              >
                <td class="pvv__opt">
                  {{ r.pickup }} {{ r.pickup === 1 ? 'pickup' : 'pickup' }}
                </td>
                <td class="num pvv__strong">
                  {{ euro(r.mensileVenditore) }}
                </td>
                <td class="num">
                  {{ euro(r.annuoVenditore) }}
                </td>
                <td class="num">
                  {{ euro(r.totaleVenditore) }}
                </td>
                <td class="num pvv__muted">
                  {{ euro(r.mensileSimba) }}
                </td>
                <td class="num">
                  {{ r.valetTotali }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="pvv__help">
          Importi senza IVA. I km oltre la fascia
          ({{ risultato.included_km === null ? 'nessun limite' : `${risultato.included_km} km` }})
          si pagano a parte, tratta per tratta, al prezzo al km impostato in Tariffe.
          <template v-if="righe.some((r) => r.mensileVenditore === null)">
            Dove il prezzo al cliente manca, l'amministratore non l'ha ancora impostato in Tariffe.
          </template>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import bookingAPI from '../services/bookingAPI.js';
import { numeriPacchetto, preventivoValet } from '../services/nuovoClienteAPI';
import { messageForError } from '../services/httpErrors';
import { isLoggedStore } from '../store/logged';

const vuoto = () => ({ address: '', street_number: '', cap: '', city: '', province: '' });
const pulito = (v) => String(v ?? '').trim();
const euroFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

export default {
  name: 'PreventivoVenditaValet',

  setup() {
    const store = isLoggedStore();
    const cliente = reactive(vuoto());
    const sedeLibera = reactive(vuoto());
    const sedi = ref([]);
    const sedeId = ref('');
    const modoSede = ref('sede');
    const mesi = ref(12);
    const tentato = ref(false);
    const calcolo = ref(false);
    const risultato = ref(null);

    onMounted(async () => {
      try {
        const res = await bookingAPI.getHeadquartersByEmployee(store.id);
        sedi.value = res?.data?.[0]?.headquarters || [];
        if (sedi.value.length === 1) sedeId.value = sedi.value[0].id;
        if (!sedi.value.length) modoSede.value = 'libera';
      } catch (e) {
        console.warn('Sedi non lette:', e?.message);
        modoSede.value = 'libera';
      }
    });

    const etichettaSede = (s) => [s.name, [s.address, s.street_number].filter(Boolean).join(' '), s.city]
      .filter(Boolean)
      .join(' · ');
    const completo = (a) => pulito(a.address) && pulito(a.city);

    const problema = computed(() => {
      if (!completo(cliente)) return "Servono almeno via e città del cliente";
      if (modoSede.value === 'sede' && !sedeId.value) return 'Scegli la sede';
      if (modoSede.value === 'libera' && !completo(sedeLibera)) return "Servono almeno via e città della sede";
      return '';
    });

    const indirizzo = (a) => ({
      address: pulito(a.address),
      street_number: pulito(a.street_number),
      cap: pulito(a.cap),
      city: pulito(a.city),
      province: pulito(a.province).toUpperCase(),
    });

    const calcola = async () => {
      tentato.value = true;
      if (problema.value) return;
      calcolo.value = true;
      try {
        risultato.value = await preventivoValet({
          origin: indirizzo(cliente),
          headquarterId: modoSede.value === 'sede' ? sedeId.value : undefined,
          destination: modoSede.value === 'libera' ? indirizzo(sedeLibera) : undefined,
        });
      } catch (e) {
        console.error('Preventivo valet non calcolato:', e);
        risultato.value = null;
        ElMessage({ type: 'error', showClose: true, message: messageForError(e) });
      } finally {
        calcolo.value = false;
      }
    };

    const righe = computed(() =>
      (risultato.value?.options || []).map((o) => numeriPacchetto(o, mesi.value)),
    );

    const fascia = (b) => (b.to_km === null ? `oltre ${b.from_km} km` : `${b.from_km}–${b.to_km} km`);
    const euro = (v) => (v === null || v === undefined ? '—' : euroFmt.format(v));

    return {
      cliente, sedeLibera, sedi, sedeId, modoSede, mesi, tentato, calcolo, risultato, problema, righe,
      etichettaSede, calcola, fascia, euro,
    };
  },
};
</script>

<style scoped>
.pvv { display: flex; flex-direction: column; gap: 16px; text-align: left; }
.pvv__card { background: #fff; border: 1px solid var(--color-border); border-radius: 6px; box-shadow: var(--el-box-shadow-lighter); overflow: hidden; }
.pvv__head { padding: 13px 18px; border-bottom: 1px solid var(--color-border); }
.pvv__title { margin: 0; font-size: 14.5px; font-weight: 600; }
.pvv__note { margin: 3px 0 0; font-size: 12.5px; color: var(--color-text-secondary); }
.pvv__body { padding: 16px 18px; display: flex; flex-direction: column; gap: 12px; }
.pvv__label {
  font-size: 11px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: var(--color-text-secondary);
}
.pvv__grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 14px; }
.pvv__f { display: flex; flex-direction: column; min-width: 0; }
.pvv__f--2 { grid-column: span 2; }
.pvv__f label { margin-bottom: 4px; font-size: 12px; font-weight: 600; color: var(--color-text-secondary); }
.pvv__sede { max-width: 480px; }

.pvv__seg { display: inline-flex; align-self: flex-start; border: 1px solid #dcdfe6; border-radius: 4px; overflow: hidden; }
.pvv__seg button {
  font: inherit; font-size: 13px; font-weight: 600; height: 30px; padding: 0 14px; border: 0;
  background: #fff; color: var(--color-text-secondary); cursor: pointer;
}
.pvv__seg button + button { border-left: 1px solid #dcdfe6; }
.pvv__seg button.is-on { background: var(--color-primary); color: #fff; }
.pvv__seg button:disabled { opacity: 0.5; cursor: default; }
.pvv__seg button:focus-visible { outline: 2px solid var(--color-primary); outline-offset: 2px; }

.pvv__actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.pvv__spacer { flex: 1 1 auto; }
.pvv__err { font-size: 12.5px; font-weight: 600; color: var(--state-attn); }
.pvv__empty { margin: 0; font-size: 13px; color: var(--color-text-secondary); }

.pvv__mesi { display: flex; align-items: center; gap: 10px; }
.pvv__mesi label { font-size: 12px; font-weight: 600; color: var(--color-text-secondary); }
.pvv__help { margin: 0; font-size: 12px; line-height: 1.5; color: var(--color-text-muted); }

.pvv__scroll { overflow-x: auto; }
.pvv__tab { width: 100%; min-width: 640px; border-collapse: collapse; }
.pvv__tab th {
  text-align: left; padding: 8px; border-bottom: 1px solid var(--color-border);
  font-size: 11px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: var(--color-text-secondary);
}
.pvv__tab td { padding: 10px 8px; border-bottom: 1px solid var(--color-bg-tertiary); font-size: 13.5px; }
.pvv__tab tr:last-child td { border-bottom: 0; }
.pvv__tab .num { text-align: right; font-variant-numeric: tabular-nums; }
.pvv__opt { font-weight: 600; }
.pvv__strong { font-weight: 700; }
.pvv__muted { color: var(--color-text-muted); }

@media (max-width: 700px) {
  .pvv__grid { grid-template-columns: 1fr 1fr; }
}
</style>
